import React, {FC} from "react"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Flex from "@irati/ui/src/Flex"
import {Label, H2} from "@irati/ui/src/Typography"
import {PaymentCurrencyType, Wallet} from "@irati/types"
import authentication from "@irati/auth"
import mainTheme from "@irati/ui/src/global/theme"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"

import {Card} from "@irati/ui/src/Layout"
import {StyledContainer} from "../styled"

interface Props {
  adminRewardWallet: Wallet
}

const AdminRewardBalance: FC<Props> = ({adminRewardWallet}) => {
  const canTopUp = authentication.apps("wallet.flexiRewards.canTopUpRewardPoints")
  const buttonText = canTopUp ? "wallet.reward.admin.btn.distribute" : "wallet.reward.admin.btn.rewardEmployees"

  return (
    <Card>
      <StyledContainer alignItems="center" justifyContent="space-around">
        <Flex direction="column" alignItems="center" marginTop={2} marginBottom={2}>
          <Label uppercase small marginBottom color={mainTheme.colors.utility.contrast}>
            <FormattedMessage id="wallet.reward.intro.currentBalance" />
          </Label>
          <Flex alignItems="flex-end">
            <H2 color={mainTheme.colors.greys.black}>
              <FormattedCurrency currency={PaymentCurrencyType.Rp} value={adminRewardWallet.amount} />
            </H2>
            <Label marginLeft={0.5} marginBottom={0.5}>
              <FormattedMessage id="wallet.reward.admin.confirmationModal.points" />
            </Label>
          </Flex>
        </Flex>
        <Flex direction="column">
          {canTopUp && (
            <ButtonRouterLink id="rewardWalletTopUpButton" to="/flexi-checkout/top-up" onClick={() => tracking.buyPoints()}>
              <FormattedMessage id="wallet.reward.admin.btn.topup" />
            </ButtonRouterLink>
          )}
          <ButtonRouterLink
            id="rewardWalletDistributeRewardsButton"
            primary
            marginTop
            to="/flexi-assign/recipients"
            onClick={() => tracking.giveRewardPoints(canTopUp ? "Admin" : "Manager")}>
            <FormattedMessage id={buttonText} />
          </ButtonRouterLink>
          <ButtonRouterLink
            marginTop
            to="flexi-reward/categories"
            onClick={() => tracking.browseRewardCatalogue(canTopUp ? "Admin" : "Manager")}>
            <FormattedMessage id="wallet.reward.admin.btn.browse" />
          </ButtonRouterLink>
        </Flex>
      </StyledContainer>
    </Card>
  )
}

export default AdminRewardBalance
